<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const menuItems = ref([
  { text: "Home", link: "https://policorp.com.br/" },
  { text: "Produtos e Serviços", link: "https://policorp.com.br/produtos-e-servicos" },
  { text: "Policorp Linux", link: "https://policorp.com.br/policorp-linux" },
  { text: "HCL", link: "https://hcl.policorp.com.br/" },
  { text: "Blog", link: "https://policorp.com.br/blog" },
  { text: "FAQ", link: "https://policorp.com.br/faq" },
  { text: "Contato", link: "https://policorp.com.br/contato" },
  { text: "Trabalhe Conosco", link: "https://policorp.com.br/trabalhe-conosco" },
  { text: "Download", link: "/" }
]);

const isMenuOpen = ref(false);
const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const closeMenu = (event) => {
  if (isMenuOpen.value && !event.target.closest('.mobile-menu') && !event.target.closest('.menu-icon')) {
    isMenuOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeMenu);
});

onUnmounted(() => {
  document.removeEventListener('click', closeMenu);
});
</script>

<template>
  <header>
  <div class="header-container">
      <div class="logo">
        <img src="/imgs/logo-policorp.png" alt="Logo Policorp" class="logo-policorp" />
      </div>
      <nav>
        <ul class="desktop-menu" v-if="!isMenuOpen">
          <li v-for="item in menuItems" :key="item.text">
            <a :href="item.link" :class="{'empresa-link': item.text === 'Download'}" class="desktop-menu-links">{{ item.text }}</a>
          </li>
        </ul>
        <div class="menu-icon" @click="toggleMenu">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="menu-overlay" v-if="isMenuOpen" @click="toggleMenu"></div>
        <ul class="mobile-menu" v-if="isMenuOpen">
          <button class="close-btn" @click="toggleMenu">X</button>
          <li v-for="item in menuItems" :key="item.text">
            <a :href="item.link">{{ item.text }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap');

* {
  box-sizing: border-box; 
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

header {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to right, #193B68, #193B68);
  color: white;
  padding: 10px 20px;
  border-bottom: 3px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100%;
}

header::before {
  content: '';
  position: absolute;
  bottom: -3px;
  left: -100%;
  width: 50%;
  height: 4px;
  background-color: rgb(120, 138, 219);
  animation: slideBorder 12s linear infinite;
}



body {
  margin-top: 80px;
}

nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 20px;
}

nav ul li a {
  color: white;
  text-decoration: none;
  font-size: 15px;
}

.desktop-menu-links {
  transition: color 0.5s, border-bottom 0.3s ease;
  position: relative;
  display: inline-block;
}

.desktop-menu-links:hover {
  color: rgb(120, 138, 219);  
}

.desktop-menu-links::after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: rgb(120, 138, 219);
  transition: width 0.3s ease; 
}

.desktop-menu-links:hover::after {
  width: 100%;
}

.empresa-link {
  color: rgb(120, 138, 219); 
}

.menu-icon {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  z-index: 1100;
}

.menu-icon div {
  width: 30px;
  height: 4px;
  background: white;
}

.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 900;
}

.mobile-menu {
  position: fixed;
  top: 0;
  right: 0;
  width: 200px;
  height: 100vh;
  background: rgba(255, 255, 255, 0.95);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  z-index: 1000;
}

.mobile-menu li {
  text-align: right;
  color: black;
}

.mobile-menu li a {
  color: black;
  transition: 0.5s;
}

.mobile-menu li a:hover {
  color: blue;
}

.close-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  background: none;
  border: none;
  color: black;
  background-color: rgba(255, 0, 0, 0.8);
  font-size: 22px;
  cursor: pointer;
  z-index: 1101;
  border: 1px solid black;
  padding: 15px;
  display: none; 
}

@media (max-width: 900px) {
  header::before {
    display: none;
  }

  .header-container {
    justify-content: space-between;
    gap: 16px;
    padding: 0 16px;
  }

  .logo {
    flex: 1;
  }

  nav {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

  .menu-icon {
    display: flex;
    margin-left: auto;
  }

  .menu-overlay {
    z-index: 1200;
  }

  .mobile-menu {
    left: 0;
    right: 0;
    width: 100%;
    max-width: none;
    padding: 80px 32px 32px;
    align-items: center;
    gap: 24px;
    z-index: 1300;
  }

  .mobile-menu li {
    width: 100%;
    text-align: center;
  }

  .mobile-menu li a {
    font-size: 20px;
  }

  .close-btn {
    display: block;
  }
}

@media (max-width: 600px) {
  .header-container {
    padding: 0 12px;
  }

  .logo-policorp {
    max-width: 160px;
  }

  .mobile-menu {
    padding: 70px 20px 20px;
  }

  .mobile-menu li a {
    font-size: 18px;
  }
}

@media (max-width: 450px) {
  .mobile-menu li {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-menu li a {
    font-size: 18px;
  }
}

@media (max-width: 1050px) {
  .desktop-menu {
    display: none;
  }
  .menu-icon {
    display: flex;
  }
}
</style>
